



















































































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MapObject } from '@/core/components/networkViewer/types';
import { Formatters } from '@/core/components/networkViewer/formatters';
import { ContextsState, SettingsState } from '@/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { LogisticsNetwork } from '@/dto/';
import _ from 'lodash';
import { guid } from '@/core/helpers/utils';
import { CONTRACTS, FetchServiceContract } from '@/core/contracts';
import Icon from '@/core/components/controls/Icon.vue';
import PackList from '@/core/components/networkViewer/Controls/PackList.vue';
@Component({
    components: {
        Icon,
        PackList
    },
})
export default class MapObjectControls extends Vue {
    // TODO openMapObjectSettings
    // TODO deletemapObject
    // TODO showAdditionalLabelWindow

    @Prop({ type: Object, required: true }) public item!: MapObject;
    @Prop({ type: Object, required: true }) public network!: LogisticsNetwork;
    @Prop({ type: Object, required: true }) public settings!: any;
    @Prop({ type: Object, required: true }) public model!: any;
    @Prop({ type: Number, required: true }) public width!: number;
    @Prop({ type: Number, required: true }) public height!: number;

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    private measureText: string = '';
    private measureStyle: string = '';
    private id: string = '';
    private showLoader: boolean = false;
    private iconCount: number = 0;
    private iconShift: number = 10;
    private controlShift: number = 14;
    private panelShift: number = -10;

    public selectMapObject(item: any, value: any) {
        this.$emit('selectMapObject', this.item, value);
    }

    public detailed(item: MapObject) {
        this.$emit('detailed', item);
    }

    private get iconSizeMultiplier() {
        return SettingsState.contextSettings.global.siteIconSizeMultiplier || 1;
    }

    private get size() {
        const iconSVGSize: number = 40;
        const iconSizeMultiplier: number = Number(this.iconSizeMultiplier);
        const size: number = iconSVGSize * iconSizeMultiplier;
        let style = 'height: ' + size.toString() + 'px; width: ' + size.toString() + 'px;';
        let iconMultiplierCounter = 0;

        switch (true) {
            case (iconSizeMultiplier < 0.7): {
                iconMultiplierCounter = 0;
                break;
            }
            case (iconSizeMultiplier >= 0.7 && iconSizeMultiplier <= 0.9): {
                iconMultiplierCounter = 2;
                break;
            }
            case (iconSizeMultiplier >= 1 && iconSizeMultiplier < 1.6): {
                iconMultiplierCounter = size / 4;
                break;
            }
            case (iconSizeMultiplier >= 1.6 && iconSizeMultiplier <= 2): {
                iconMultiplierCounter = size / 3;
                break;
            }
        }

        style = style + 'margin: -' + iconMultiplierCounter + 'px;';

        return style;
    }

    private get show() {
        this.getId();
        this.iconCount = this.item.icons?.length ?? 0;
        let result = _.isEqual(this.network.state.selectedMapObject, this.item);
        result = result || this.settings.showNetworkLabels;
        result = result || this.network.state.mapIsMoving;
        result =
            result && this.item.name !== null && this.item.name !== undefined;

        return result;
    }

    private get getZIndex() {
        if (this.item.selected) {
            return 10;
        } else {
            return 3;
        }
    }

    private getChildren(data: any) {
        if (this.item.data !== null && this.item.data !== undefined) {
            return this.item.data.filter(
                (item: MapObject) => item.id !== this.item.id
            );
        } else {
            return this.item.data;
        }
    }

    private getId() {
        this.id = guid();
    }

    private getWidth(text: string, styles: string) {
        this.measureText = text;
        this.measureStyle = styles;

        const name = 'measure';
        const div = this.$refs[name] as HTMLElement;

        return div.clientWidth;
    }

    private get cssLeft2() {
        let result = Formatters.prototype.norm_square(
            this.item?.capacity ?? 0,
            0,
            this.network.state.general.maxFlow,
            this.network.preferences.mapObject.minDisplayCapacityRadius,
            this.network.preferences.mapObject.maxDisplayCapacityRadius
        );
        result = Formatters.prototype.add(result, 4);
        result = Formatters.prototype.max(
            result,
            this.network.preferences.mapObject.minDisplayCapacityRadius
        );
        result = Formatters.prototype.ifNaN(result, 0);
        result = Formatters.prototype.mul(result, 2);
        result = Formatters.prototype.add(result, this.width);
        result = Formatters.prototype.add(result, 11);
        result = Formatters.prototype.invert(result);

        return result;
    }

    private get cssLeft() {
        let result = -this.iconShift;
        result = Formatters.prototype.add(result, this.item.x);
        result = Formatters.prototype.add(
            result,
            this.network.state.offset.x ?? 0
        );

        if (this.network.window.width) {
            const offset =
                (this.network.window.width - this.network.state.width) / 2;
            result -= offset;
        }
        return result;
    }

    private get cssTop() {
        let result = -this.iconShift;
        result = Formatters.prototype.add(result, this.item.y);
        result = Formatters.prototype.add(
            result,
            this.network.state.offset.y ?? 0
        );

        if (this.network.window.height) {
            const offset =
                (this.network.window.height - this.network.state.height) / 2;
            result -= offset;
        }
        return result;
    }

    private get cssPanelLeft() {
        let result = Formatters.prototype.norm_square(
            this.item.capacity ?? 0,
            0,
            this.network.state.mapObjects.maxCapacity ?? 0,
            this.network.preferences.mapObject.minDisplayCapacityRadius,
            this.network.preferences.mapObject.maxDisplayCapacityRadius
        );
        result = Formatters.prototype.max(
            result,
            this.network.preferences.mapObject.minDisplayCapacityRadius
        );
        return result + this.panelShift;
    }

    private shorten(value: any) {
        return Formatters.prototype.shorten(value);
    }

    // show group mapObjects from ui
    private async showGroupMapObjects(group: any, event: any) {
        if (!this.item.isGroup) {
            return;
        }

        if (!this.item.nameEditable) {
            this.showLoader = true;
            this.item.expanded = !this.item.expanded;

            if (!this.item.expanded) {
                this.item.data = null;
            } else {
                const data = await this.getMapObjects(this.item.groupId);

                if (this.item.expanded) {
                    this.item.data = null;
                    this.item.data = data;
                }
            }

            this.showLoader = false;
            this.getId();
        }
    }

    private async getMapObjects(groupId: any) {
        const contextId = ContextsState.currentContextId;
        const url = `/contexts/${contextId}/map/viewport/${groupId}/sites`;
        const data = await this._fetchService!.get<MapObject[]>(url);

        return data;
    }

    // enable edit name from ui for rv-editable binder
    private enableEditName(object: any) {
        object.nameEditable = true;
    }

    private get isVehicle() {
        return this.item.objectType === 1;
    }
}
